import { patchToApi } from "venuescanner-js/services/api";

export const updateNumber = (newNumber) =>
  patchToApi(`users/me`, { preferred_phone_number: newNumber });
